import { render, staticRenderFns } from "./bannerads.vue?vue&type=template&id=73189b4e&scoped=true&"
import script from "./bannerads.vue?vue&type=script&lang=js&"
export * from "./bannerads.vue?vue&type=script&lang=js&"
import style0 from "./bannerads.vue?vue&type=style&index=0&id=73189b4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73189b4e",
  null
  
)

export default component.exports